<template>
    <div class="account-manage-page">
        <el-card class="page-card">
            <template #header>
                <div class="card-header">账户管理</div>
            </template>

            <div class="card-body">
                <el-row type="flex" justify="space-between" align="middle" class="toolbar">
                    <el-col>
                        <el-button type="primary" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
                    </el-col>
                    <el-col>
                        <el-input size="small" placeholder="按公司ID过滤" v-model="filters.company_id" style="width:220px"
                            clearable>
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
                        </el-input>
                        <el-input size="small" placeholder="关键字（账户名/描述）" v-model="filters.keyword"
                            style="width:220px; margin-left:8px" clearable>
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
                        </el-input>
                        <el-button size="small" type="primary" style="margin-left:8px"
                            @click="handleSearch">搜索</el-button>
                        <el-button size="small" @click="handleReset" style="margin-left:8px">重置</el-button>
                    </el-col>
                </el-row>

                <el-table :data="pageData" stripe border style="width: 100%; margin-top: 12px"
                    row-key="company_account_id" :loading="loading">
                    <el-table-column prop="company_id" label="公司ID" width="120" align="center" header-align="center" />
                    <el-table-column prop="product_name" label="账户名称" align="center"
                        header-align="center"></el-table-column>
                    <el-table-column prop="account_amount" label="余额" align="center"
                        header-align="center"></el-table-column>
                    <el-table-column v-if="isSuperAdmin" prop="api_key" label="api_key" width="300" align="center"
                        header-align="center"></el-table-column>
                    <el-table-column v-if="isSuperAdmin" prop="api_secret" label="api_secret" width="300" align="center"
                        header-align="center"></el-table-column>
                    <el-table-column prop="status" label="状态" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small"
                                :type="row.status === 1 ? 'success' : (row.status === 2 ? 'warning' : 'danger')">{{
                                    formatStatus(row.status) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="300" align="center" header-align="center" />
                    <el-table-column label="操作" fixed="right" width="320" align="center" header-align="center">
                        <template slot-scope="scope">
                            <el-button v-if="hasConfigPermission" size="mini"
                                @click="handleConfig(scope.row)">配置</el-button>
                            <el-button v-if="hasTopupPermission" size="mini"
                                @click="handleTransfer(scope.row)">充值</el-button>
                            <el-button v-if="hasRecordPermission" size="mini"
                                @click="handleRecord(scope.row)">记录</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination-wrap">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                        :page-sizes="[10, 15, 20, 50]" :page-size.sync="pager.pageSize" :current-page.sync="pager.page"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-card>

        <!-- 配置对话框 -->
        <el-dialog :visible.sync="configDialog" title="账户配置" width="1200px" :close-on-click-modal="false">
            <div v-loading="configLoading" class="config-content">
                <el-form :model="configForm" label-width="180px" :disabled="configLoading">
                    <el-form-item v-if="currentProductId === 5" label="关单接口" prop="close_order" :required="false">
                        <el-input v-model="configForm.close_order" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item v-if="currentProductId === 5" label="下单接口" prop="create_order" :required="false">
                        <el-input v-model="configForm.create_order" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item v-if="currentProductId === 5" label="支付状态查询接口" prop="order_status_inquiry"
                        :required="false">
                        <el-input v-model="configForm.order_status_inquiry" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item v-if="currentProductId === 5" label="订单状态变更推送接口" prop="order_status_edit"
                        :required="false">
                        <el-input v-model="configForm.order_status_edit" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item v-if="currentProductId === 5" label="退款接口" prop="refund_order" :required="false">
                        <el-input v-model="configForm.refund_order" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item v-if="currentProductId === 5" label="收银台的地址" prop="cashier_url" :required="false">
                        <el-input v-model="configForm.cashier_url" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="服务费类型" prop="service_fee_type" :required="false">
                        <el-select v-model="configForm.service_fee_type" placeholder="请选择">
                            <el-option label="固定" :value="1"></el-option>
                            <el-option label="百分比" :value="2"></el-option>
                            <el-option label="阶梯固定" :value="3"></el-option>
                            <el-option label="阶梯百分比" :value="4"></el-option>
                            <el-option label="时间（月）" :value="5"></el-option>
                            <el-option label="接口调用次数收费" :value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="configForm.service_fee_type" label="服务费类型内容" prop="service_fee_type_content"
                        :required="false">
                        <!-- 阶梯固定类型使用可视化输入框 -->
                        <template v-if="configForm.service_fee_type === 3">
                            <div v-for="(rule, index) in ladderRules" :key="index" class="ladder-rule-group">
                                <el-input-number v-model.number="rule.min" placeholder="最小" :precision="2"
                                    style="width: 200px; margin-right: 10px;"></el-input-number>
                                <el-input-number v-model.number="rule.max" placeholder="最大" :precision="2"
                                    style="width: 200px; margin-right: 10px;"></el-input-number>
                                <el-input-number v-model.number="rule.fee" placeholder="费用" :precision="2"
                                    style="width: 200px; margin-right: 10px;"></el-input-number>
                                <el-button type="danger" icon="el-icon-delete" size="small"
                                    @click="removeLadderRule(index)"></el-button>
                            </div>
                            <el-button type="primary" icon="el-icon-plus" size="small" @click="addLadderRule"
                                style="margin-top: 10px;">添加规则</el-button>
                        </template>
                        <!-- 阶梯百分比类型使用可视化输入框 -->
                        <template v-else-if="configForm.service_fee_type === 4">
                            <div v-for="(rule, index) in ladderPercentRules" :key="index" class="ladder-rule-group"
                                style="display: flex; align-items: center;">
                                <el-input-number v-model.number="rule.min" placeholder="最小" :precision="2"
                                    style="width: 200px; margin-right: 10px;"></el-input-number>
                                <el-input-number v-model.number="rule.max" placeholder="最大" :precision="2"
                                    style="width: 200px; margin-right: 10px;"></el-input-number>
                                <div style="position: relative; width: 200px; margin-right: 10px;">
                                    <el-input-number v-model.number="rule.rate" placeholder="比率" :precision="2"
                                        style="width: 100%;"></el-input-number>
                                    <span
                                        style="position: absolute; right: 50px; top: 50%; transform: translateY(-50%); pointer-events: none;">%</span>
                                </div>
                                <el-button type="danger" icon="el-icon-delete" size="small"
                                    @click="removeLadderPercentRule(index)"></el-button>
                            </div>
                            <el-button type="primary" icon="el-icon-plus" size="small" @click="addLadderPercentRule"
                                style="margin-top: 10px;">添加规则</el-button>
                        </template>
                        <!-- 其他类型继续使用文本输入框 -->
                        <el-input v-else v-model="configForm.service_fee_type_content" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="configDialog = false">取消</el-button>
                <el-button type="primary" @click="saveConfig" :loading="configLoading">保存配置</el-button>
            </span>
        </el-dialog>

        <!-- 充值对话框 -->
        <el-dialog :visible.sync="transferDialog" title="账户充值" width="500px" :close-on-click-modal="false">
            <div v-loading="transferLoading">
                <el-form :model="transferForm" label-width="100px" :disabled="transferLoading">
                    <el-form-item label="充值金额" prop="amount" :required="true">
                        <el-input v-model.number="transferForm.amount" placeholder="请输入充值金额" type="number" min="0"
                            step="0.01"></el-input>
                    </el-form-item>
                    <el-form-item label="上传凭证" prop="voucher" :required="false">
                        <el-upload class="upload-demo" action="" :auto-upload="false" :on-change="handleFileChange"
                            :on-remove="handleRemove" :file-list="transferForm.voucher" :limit="9" multiple
                            list-type="picture-card">
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="tip" class="el-upload__tip">最多上传9张图片，支持jpg、jpeg、png格式</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark" :required="false">
                        <el-input v-model="transferForm.remark" placeholder="请输入备注（非必传）" type="textarea"
                            rows="3"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="transferDialog = false">取消</el-button>
                <el-button type="primary" @click="confirmTransfer" :loading="transferLoading">确认充值</el-button>
            </span>
        </el-dialog>

        <!-- 记录对话框 -->
        <el-dialog :visible.sync="recordDialog" title="账户记录" width="80%" :close-on-click-modal="false">
            <div v-loading="recordLoading">
                <el-table :data="recordList" stripe border style="width: 100%" :loading="recordLoading">
                    <el-table-column prop="company_id" label="公司ID" width="100" align="center" header-align="center" />
                    <el-table-column prop="type" label="交易类型" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small" :type="getTypeTagType(row.type)">{{
                                getTypeText(row.type)
                            }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="交易金额" width="100" align="center" header-align="center" />
                    <el-table-column prop="direction" label="出/入账" width="100" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small" :type="row.direction === 1 ? 'success' : 'danger'">{{
                                row.direction === 1 ? '入账' : '出账'
                            }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="balance_before" label="操作前余额" width="100" align="center"
                        header-align="center" />
                    <el-table-column prop="balance_after" label="操作后余额" width="100" align="center"
                        header-align="center" />
                    <el-table-column prop="operator_name" label="操作人" align="center" width="100"
                        header-align="center"></el-table-column>
                    <el-table-column prop="voucher" label="凭证" align="center" header-align="center" />
                    <el-table-column prop="remark" label="备注" align="center" header-align="center" />
                    <el-table-column prop="created_at" label="创建时间" align="center" header-align="center" />

                </el-table>

                <div class="pagination-wrap" style="margin-top: 12px;">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="recordTotal"
                        :page-sizes="[10, 15, 20, 50]" :page-size.sync="recordPager.pageSize"
                        :current-page.sync="recordPager.page" @size-change="handleRecordSizeChange"
                        @current-change="handleRecordCurrentChange" />
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="recordDialog = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { accountList, accountDetail, accountConfig, accountTransfer, accountRecord, imageUploads } from '@/api/api'
import { hasPermission, getUserInfo } from '@/utils/auth'
import dayjs from 'dayjs'

export default {
    name: 'AccountManage',
    data() {
        return {
            loading: false,
            list: [],
            serverSide: true,
            pager: { page: 1, pageSize: 15 },
            total: 0,
            filters: { company_id: '', keyword: '' },
            // 详情
            detailDialog: false,
            detailRow: null,
            // 配置
            configDialog: false,
            configForm: {
                close_order: '',
                create_order: '',
                order_status_inquiry: '',
                order_status_edit: '',
                refund_order: '',
                cashier_url: ''
            },
            ladderRules: [
                {
                    min: '',
                    max: '',
                    fee: ''
                }
            ],
            ladderPercentRules: [],
            configLoading: false,
            // 充值
            transferDialog: false,
            transferForm: {
                company_account_id: '',
                amount: '',
                voucher: [],
                remark: ''
            },
            transferLoading: false,
            // 记录
            recordDialog: false,
            recordList: [],
            recordLoading: false,
            recordPager: { page: 1, pageSize: 15 },
            recordTotal: 0,
            currentCompanyAccountId: '',
            // 当前操作行的product_id
            currentProductId: ''
        }
    },
    computed: {
        pageData() {
            if (this.serverSide) return this.list
            const start = (this.pager.page - 1) * this.pager.pageSize
            return this.list.slice(start, start + this.pager.pageSize)
        },
        // 按钮权限检查
        hasConfigPermission() {
            return hasPermission('configuration')
        },
        hasTopupPermission() {
            return hasPermission('topup')
        },
        hasRecordPermission() {
            return hasPermission('record')
        },
        // 判断用户是否是平台超级管理员（id为2）
        isSuperAdmin() {
            const userInfo = getUserInfo()
            if (!userInfo || !userInfo.role || !Array.isArray(userInfo.role)) {
                return false
            }
            // 循环用户角色数组，检查是否有id为2的角色（平台超级管理员）
            return userInfo.role.some(role => role.id === 2)
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        formatStatus(s) {
            if (s === 1 || s === '1') return '开通'
            if (s === 0 || s === '0') return '关闭'
            return s === undefined || s === null ? '-' : String(s)
        },
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.pager.page,
                    per_page: this.pager.pageSize,
                    company_id: this.filters.company_id || undefined,
                    keyword: this.filters.keyword || undefined
                }
                const res = await accountList(params)

                this.list = res.data.data
                // 设置总数用于分页
                this.total = res.data.total || 0

            } catch (err) {
                console.error('accountList error', err)
                this.$message.error(err.message || '获取账户列表失败')
            } finally {
                this.loading = false
            }
        },
        normalize(item) {
            return {
                company_account_id: item.company_account_id || item.id || item.company_account_id,
                company_id: item.company_id || '',
                account_name: item.account_name || item.account || '',
                balance: typeof item.balance !== 'undefined' ? item.balance : item.money || item.amount,
                status: typeof item.status !== 'undefined' ? item.status : (item.raw && item.raw.status),
                created_at: item.created_at ? dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss') : (item.createdAt ? dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss') : '')
            }
        },
        handleSizeChange(size) {
            this.pager.pageSize = size
            this.pager.page = 1
            this.fetchData()
        },
        handleCurrentChange(page) {
            this.pager.page = page
            this.fetchData()
        },
        async handleDetails(row) {
            // 弹窗并请求详情接口以获取最新完整信息
            this.detailDialog = true
            this.detailRow = null
            try {
                const params = { company_account_id: row.company_account_id || row.id }
                const res = await accountDetail(params)
                // 尝试从常见返回位置取数据
                const data = (res && res.data) ? res.data : (res && res.company_account) ? res.company_account : res
                this.detailRow = data ? this.normalize(data) : row
            } catch (err) {
                console.error('accountDetail error', err)
                this.$message.error(err.message || '获取账户详情失败')
                this.detailRow = row
            }
        },
        async handleConfig(row) {
            // 打开配置对话框并请求详情
            this.configDialog = true
            this.configLoading = true
            try {
                const params = { company_account_id: row.company_account_id || row.id }
                const res = await accountDetail(params)
                // 尝试从常见返回位置取数据
                const data = res.data

                // 回显数据到配置表单
                // 存储当前操作行的product_id
                this.currentProductId = row.product_id || '';
                this.configForm = {
                    company_account_id: row.company_account_id || row.id,
                    close_order: data.close_order,
                    create_order: data.create_order,
                    order_status_inquiry: data.order_status_inquiry,
                    order_status_edit: data.order_status_edit,
                    refund_order: data.refund_order,
                    cashier_url: data.cashier_url,
                    service_fee_type: data.service_fee_type,
                    service_fee_type_content: data.service_fee_type_content
                }

                // 初始化阶梯规则
                if (this.configForm.service_fee_type === 3 && this.configForm.service_fee_type_content) {
                    try {
                        const rules = JSON.parse(this.configForm.service_fee_type_content)
                        if (Array.isArray(rules)) {
                            this.ladderRules = rules.map(rule => ({
                                min: rule.min !== undefined ? rule.min : '',
                                max: rule.max !== undefined ? rule.max : '',
                                fee: rule.fee !== undefined ? rule.fee : ''
                            }))
                        }
                    } catch (e) {
                        // 如果解析失败，使用默认的一组空规则
                        this.ladderRules = [{ min: '', max: '', fee: '' }]
                    }
                } else {
                    this.ladderRules = [{ min: '', max: '', fee: '' }]
                }

                // 初始化阶梯百分比规则
                if (this.configForm.service_fee_type === 4 && this.configForm.service_fee_type_content) {
                    try {
                        const rules = JSON.parse(this.configForm.service_fee_type_content)
                        if (Array.isArray(rules)) {
                            this.ladderPercentRules = rules.map(rule => ({
                                min: rule.min !== undefined ? rule.min : '',
                                max: rule.max !== undefined ? rule.max : '',
                                rate: rule.rate !== undefined ? rule.rate : ''
                            }))
                        }
                    } catch (e) {
                        // 如果解析失败，使用默认的一组空规则
                        this.ladderPercentRules = [{ min: '', max: '', rate: '' }]
                    }
                } else {
                    this.ladderPercentRules = [{ min: '', max: '', rate: '' }]
                }
            } catch (err) {
                console.error('accountDetail error', err)
                this.$message.error(err.message || '获取账户详情失败')
                this.ladderPercentRules = [{ min: '', max: '', rate: '' }]
            } finally {
                this.configLoading = false
            }
        },

        // 添加阶梯规则
        addLadderRule() {
            this.ladderRules.push({
                min: '',
                max: '',
                fee: ''
            })
        },

        // 删除阶梯规则
        removeLadderRule(index) {
            if (this.ladderRules.length > 1) {
                this.ladderRules.splice(index, 1)
            } else {
                this.$message.warning('至少保留一条规则')
            }
        },

        // 添加阶梯百分比规则
        addLadderPercentRule() {
            this.ladderPercentRules.push({
                min: '',
                max: '',
                rate: ''
            })
        },

        // 删除阶梯百分比规则
        removeLadderPercentRule(index) {
            if (this.ladderPercentRules.length > 1) {
                this.ladderPercentRules.splice(index, 1)
            } else {
                this.$message.warning('至少保留一条规则')
            }
        },

        // 同步阶梯规则到service_fee_type_content
        syncLadderRules() {
            if (this.configForm.service_fee_type === 3) {
                // 过滤有效规则并确保格式正确
                const validRules = this.ladderRules.filter(rule =>
                    rule.min !== null && rule.min !== undefined && rule.min !== '' &&
                    rule.max !== null && rule.max !== undefined && rule.max !== '' &&
                    rule.fee !== null && rule.fee !== undefined && rule.fee !== ''
                ).map(rule => ({
                    min: Number(rule.min), // 确保为数字类型
                    max: Number(rule.max),
                    fee: Number(rule.fee)
                }))
                // 生成严格格式的JSON字符串，确保不包含额外空格
                this.configForm.service_fee_type_content = JSON.stringify(validRules)
            } else if (this.configForm.service_fee_type === 4) {
                // 过滤有效规则并确保格式正确
                const validRules = this.ladderPercentRules.filter(rule =>
                    rule.min !== null && rule.min !== undefined && rule.min !== '' &&
                    rule.max !== null && rule.max !== undefined && rule.max !== '' &&
                    rule.rate !== null && rule.rate !== undefined && rule.rate !== ''
                ).map(rule => ({
                    min: Number(rule.min), // 确保为数字类型
                    max: Number(rule.max),
                    rate: Number(rule.rate)
                }))
                // 生成严格格式的JSON字符串，确保不包含额外空格
                this.configForm.service_fee_type_content = JSON.stringify(validRules)
            }
        },

        async saveConfig() {
            // 保存配置
            this.configLoading = true
            try {
                // 同步阶梯规则数据
                this.syncLadderRules()

                await accountConfig(this.configForm)
                this.$message.success('配置保存成功')
                this.configDialog = false
                // 保存成功后刷新列表
                this.fetchData()
            } catch (err) {
                console.error('accountConfig error', err)
                this.$message.error(err.message || '配置保存失败')
            } finally {
                this.configLoading = false
            }
        },
        handleTransfer(row) {
            // 打开充值对话框
            this.transferForm = {
                company_account_id: row.id || row.company_account_id,
                amount: '',
                voucher: [],
                remark: ''
            }
            this.transferDialog = true
        },

        async handleFileChange(file, fileList) {
            // 处理文件变化
            this.transferForm.voucher = fileList

            // 如果有新文件，上传图片
            if (file && file.raw) {
                try {
                    // 创建FormData对象
                    const formData = new FormData()

                    // 添加图片文件到FormData，字段名为image，类型为array
                    formData.append('image', file.raw)

                    // 显示上传中的提示
                    this.$message.info('图片上传中...')

                    // 调用上传接口
                    const res = await imageUploads(formData)

                    // 上传成功提示
                    this.$message.success('图片上传成功')
                    console.log('图片上传结果:', res)

                    // 可以在这里处理上传成功后的逻辑，例如保存返回的图片URL等
                    // 如果需要更新file对象的其他属性，可以通过索引找到对应的文件
                    const index = this.transferForm.voucher.findIndex(item => item.uid === file.uid)
                    if (index !== -1) {
                        // 根据接口返回结构，可能需要更新文件信息
                        this.$set(this.transferForm.voucher, index, { ...this.transferForm.voucher[index], response: res })
                    }
                } catch (error) {
                    console.error('图片上传失败:', error)
                    this.$message.error(error.message || '图片上传失败')
                    // 上传失败时移除该文件
                    this.transferForm.voucher = this.transferForm.voucher.filter(item => item.uid !== file.uid)
                }
            }
        },

        handleRemove(file, fileList) {
            // 处理图片删除
            this.transferForm.voucher = fileList
        },

        async confirmTransfer() {
            console.log('000000', this.transferForm);

            // 验证表单
            if (!this.transferForm.amount || this.transferForm.amount <= 0) {
                this.$message.warning('请输入有效的充值金额')
                return
            }

            // if (!this.transferForm.voucher || this.transferForm.voucher.length === 0) {
            //     this.$message.warning('请上传充值凭证')
            //     return
            // }

            this.transferLoading = true
            try {
                // 准备表单数据
                const formData = new FormData()
                formData.append('company_account_id', this.transferForm.company_account_id)
                formData.append('amount', this.transferForm.amount)

                // 添加备注（如果有）
                if (this.transferForm.remark) {
                    formData.append('remark', this.transferForm.remark)
                }

                // 添加文件
                this.transferForm.voucher.forEach((file) => {
                    formData.append('voucher', file.raw)
                })

                // 调用充值接口
                await accountTransfer(formData)

                this.$message.success('充值成功')
                this.transferDialog = false
                // 刷新数据
                this.fetchData()
            } catch (err) {
                console.error('accountTransfer error', err)
                this.$message.error(err.message || '充值失败')
            } finally {
                this.transferLoading = false
            }
        },
        handleRecord(row) {
            // 跳转到账户记录详情页面
            const accountId = row.id || row.company_account_id
            this.$router.push({
                path: '/account/record',
                query: { company_account_id: accountId }
            })
        },

        async fetchRecordData() {
            this.recordLoading = true
            try {
                const params = {
                    company_account_id: this.currentCompanyAccountId,
                    page: this.recordPager.page,
                    per_page: this.recordPager.pageSize
                }
                const res = await accountRecord(params)
                console.log('获取账户记录', res.data.total);

                this.recordList = res.data.data || []
                this.recordTotal = res.data.total || res.data.count || 0
            } catch (err) {
                console.error('accountRecord error', err)
                this.$message.error(err.message || '获取账户记录失败')
                this.recordList = []
                this.recordTotal = 0
            } finally {
                this.recordLoading = false
            }
        },

        handleRecordSizeChange(size) {
            this.recordPager.pageSize = size
            this.recordPager.page = 1
            this.fetchRecordData()
        },

        handleRecordCurrentChange(page) {
            this.recordPager.page = page
            this.fetchRecordData()
        },

        // 搜索
        handleSearch() {
            this.pager.page = 1
            this.fetchData()
        },

        // 重置搜索条件并刷新页面
        handleReset() {
            this.filters = {
                company_id: '',
                keyword: ''
            }
            this.pager.page = 1
            this.fetchData()
        },

        // 获取交易类型文本
        getTypeText(type) {
            const typeMap = {
                1: '充值',
                2: '消费',
                3: '退款',
                4: '调整'
            }
            return typeMap[type] || '未知'
        },

        // 获取交易类型标签颜色
        getTypeTagType(type) {
            const typeColorMap = {
                1: 'success', // 充值-绿色
                2: 'danger',  // 消费-红色
                3: 'warning', // 退款-黄色
                4: 'info'     // 调整-蓝色
            }
            return typeColorMap[type] || 'default'
        }
    }
}
</script>

<style scoped>
.page-card {
    margin: 20px 12px;
    height: calc(100vh - 64px - 48px);
    overflow-y: auto;
}

.card-header {
    font-weight: 700;
    color: #409EFF;
}

.card-body {
    padding: 12px;
}

.toolbar {
    margin-bottom: 6px;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}

.config-content {
    min-height: 200px;
}
</style>
